import { useSWRFetch } from '@hooks/useSWRFetch';
import { Request } from '@hooks/useSWRFetch/types';
import { TEN_MINUTES_IN_MS } from '@helpers/constants';
import { buildAlbumUriFromId, isEmptyString } from '@helpers/utils';
import { DeliveryXmlFilesResponse } from './types';

export const useProductXmlDeliveredFiles = (
  albumUriId = '',
  feedGid = '',
  deliveryId = '',
  productId = '',
) => {
  const encodedProductId = encodeURIComponent(productId);
  const encodedDeliveryId = encodeURIComponent(deliveryId);
  const searchParams = new URLSearchParams();

  searchParams.append('albumUri', buildAlbumUriFromId(albumUriId));
  searchParams.append('feedGid', feedGid);
  searchParams.append('deliveryId', encodedDeliveryId);
  searchParams.append('productId', encodedProductId);

  const requestObject: Request = {
    url: `catalog/api/productxmlfiles?${new URLSearchParams(searchParams)}`,
    baseUrl: '',
  };

  const canRequest =
    !isEmptyString(albumUriId) &&
    !isEmptyString(feedGid) &&
    !isEmptyString(deliveryId) &&
    !isEmptyString(productId);

  return useSWRFetch<DeliveryXmlFilesResponse>(
    canRequest ? requestObject : null,
    {
      dedupingInterval: TEN_MINUTES_IN_MS,
    },
  );
};
